<script>
  import { auth, db } from "../firebase";
  import { collectionData } from "rxfire/firestore";
  import { startWith } from 'rxjs/operators';
  import SubmittedLoan from './SubmittedLoan.svelte';

  let user;

  const unfinishedLoansQuery = db.collection("submittedLoans")
    .where("completed", "==", false)
    .orderBy("created", "desc");

  const loans = collectionData(unfinishedLoansQuery, "id").pipe(startWith([]));

  // Get user again by auth to verify access
  db.collection("users")
    .doc(auth.currentUser.uid)
    .get()
    .then(function(userDoc) {
      user = userDoc.data();
    });
</script>

{#if user && user.isAdmin}
  {#each $loans as loan}
    <div>
      <SubmittedLoan {loan} />
    </div>
  {/each}
{/if}
